module.exports = __webpack_public_path__ + "media/images/new_home/dig-in-day-photo-26a4ef236307cb40e391a59e9719a615.png";